import { v4 as uuidv4 } from "uuid";
import { Component } from "./component";
import { ImplementationMethodResponse } from "./implementation/method";
import { NotebookPage } from "./note";
import { Protocol, ProtocolFunctionSpec, ProtocolSpec } from "./protocol";

export enum IMPLEMENTATION_LANGUAGE {
  PYTHON = "python",
  OQL = "oql",
}

export interface Implementation {
  type: "omega/query-omega/implementation/Implementation";
  name: string;
  "app-id": string;
  "page-id": string;
  "protocol-id": string;
  "implementation-id": string;
  "component-id": string;
  language?: IMPLEMENTATION_LANGUAGE;
  code: string;
}

export const newImplementation = (config: {
  name: string;
  page: NotebookPage;
  comp: Component;
  proto: Protocol;
}) => {
  const { name, page, comp, proto } = config;
  const impl: Implementation = {
    type: "omega/query-omega/implementation/Implementation",
    name,
    "app-id": page["app-id"],
    "page-id": page["page-id"],
    "protocol-id": proto["protocol-id"],
    "component-id": comp["component-id"],
    "implementation-id": uuidv4(),
    language: IMPLEMENTATION_LANGUAGE.OQL,
    code: "",
  };
  return impl;
};

export type ImplementationMap = { [k: string]: Implementation };

export type PageImplementationsMap = { [k: string]: string[] };

export interface ImplementationContextValue {
  implementation: Implementation | undefined;
  protocol: Protocol | undefined;
  component: Component | undefined;
  selectedMethodIndex: number;
  setSelectedMethodIndex: (index: number) => void;
  onRunCallback: () => Promise<any>;
  setImplementationCode: (code: string) => Promise<void>;
  setImplementationName: (name: string) => Promise<void>;
  runResponse: ImplementationMethodResponse | undefined;
  setRunResponse: (response: ImplementationMethodResponse | undefined) => void;
  selectedMethod: ProtocolFunctionSpec | undefined;
  functionArgs: string[];
  setFunctionArg: (i: number, arg: string) => void;
  spec: ProtocolSpec;
  setImplementationLanguage: (
    language: IMPLEMENTATION_LANGUAGE,
  ) => Promise<void>;
  implementationLanguage: IMPLEMENTATION_LANGUAGE;
}
